import Vue from 'vue';
import iniciarGoogleMaps from '../utils/google-maps';

Vue.prototype.$iniciarGoogleMaps = iniciarGoogleMaps(
    process.env.VUE_APP_GOOGLE_API_KEY ?? '',
    {
        libraries:'places'
    }
);
